export default "__VITE_ASSET__DltJIgh3__"